import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthStore from "../../stores/AuthStore";
import { getParamFromUrlSearch } from "../../utils/paramsUtil";
import { observer } from "mobx-react-lite";

const SSOGetInfoPage: React.FC = (props) => {
  const navigate = useNavigate();
  const { ssoIsLogin } = AuthStore;

  const systemKey = window.CONFIG.systemKey;
  const account = localStorage.getItem(`${systemKey}-account`);

  useEffect(() => {
    const params = getParamFromUrlSearch<{ token?: string }>(
      document.location.search
    );
    if(!params.token) {
      ssoIsLogin ? AuthStore.getUserInfoByAccount(account ?? "") : navigate("/");
      return;
    }else{
      // 钉钉登录
      params.token === "null"
        ? navigate("/403/1")
        : AuthStore.getUserInfo(params.token)
    }
    // params.token
    //   ? params.token === "null"
    //     ? navigate("/403/1")
    //     : AuthStore.getUserInfo(params.token)
    //   : navigate("/");
  }, []);

  return <div></div>;
};

export default observer(SSOGetInfoPage);
